export { default as Wave1 } from "./Wave1";
export { default as Wave2 } from "./Wave2";
